<template>
  <div>
    <div class="text-h6">
      Go to your authentication app
    </div>
    <p>
      Enter the 6-digit code for this account from the
      two-factor authentication app you set up
      (such as Duo Mobile or Google Authenticator).
    </p>
    <form @submit.prevent="submitCode">
      <q-input v-model="code" maxlength="6" outlined autofocus />
      <message v-if="result.error" type="negative" class="q-mt-md">
        {{ result.error }}
      </message>
      <div class="text-center q-my-md">
        <async-btn
          :task="task"
          type="submit"
          label="Continue"
          color="primary"
          class="full-width"
          rounded
        />
      </div>
    </form>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { HasTaskMixin } from '@/mixins';
import AsyncBtn from '@/components/AsyncBtn.vue';
import Message from '@/components/message/Message.vue';
import { submitAuthAppCode, LoginResult } from '.';

interface Data {
  code: string,
  task: Promise<LoginResult>|null,
}

export default defineComponent({
  emits: ['error', 'result'],
  components: { Message, AsyncBtn },
  mixins: [HasTaskMixin],
  props: {
    sessionId: {
      type: String,
      required: true,
    },
    result: {
      type: Object as () => LoginResult,
      required: true,
    },
  },
  data(): Data {
    return {
      code: '',
      task: null,
    };
  },
  methods: {
    submitCode() {
      this.task = submitAuthAppCode(this.sessionId, this.code);
      this.task.then((result) => {
        this.$emit('result', result);
      });
      this.task.catch(() => {
        this.$emit('error');
      });
    },
  },
});
</script>
